import React, { useState } from "react";
import { Classes, Button, Dialog, Label, InputGroup } from "@blueprintjs/core";
import DialogButton from "./DialogButton";
import api from "../../common/lib/api";

function PairDeviceDialog({ token, onClose }) {
  const [value, setValue] = useState("");
  return (
    <Dialog isOpen onClose={onClose} title="Pair Device">
      <div className={Classes.DIALOG_BODY}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            pair(token, value);
          }}
        >
          <Label>
            Please enter your pairing code.
            <InputGroup
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Label>
          <Button type="submit">Pair</Button>
        </form>
      </div>
    </Dialog>
  );
}

async function pair(token, pairingCode) {
  api.login(token);
  try {
    await api.post("/devices", { pairingCode });
    alert("success");
    window.location.reload();
  } catch (e) {
    alert(e.message);
  }
}

export default function PairDeviceButton({ token }) {
  return (
    <DialogButton dialog={PairDeviceDialog} token={token}>
      Pair Device
    </DialogButton>
  );
}
